export const localValidate = (formState) => {
  let errors = {};

  return errors;
};

const OrgUnitAdminPurchases = async (formState) => {
  let errors = localValidate(formState);

  return errors ? errors : {};
};

export default OrgUnitAdminPurchases;